import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardServiceService } from '../../services/dashboard-service.service';
import { DynamicModalComponent } from '../../modals/dynamic-modal/dynamic-modal.component';
import { NewFutureModalComponent } from '../../modals/new-future-modal/new-future-modal.component';
import { PurchaseModalComponent } from '../../modals/purchase-modal/purchase-modal.component';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  data: any;
  constructor(
    private dialog: MatDialog,
    private dashboardService: DashboardServiceService,
    private global:GlobalService
  ) {
    // method to handle any additional initialization tasks.
  }

  ngOnInit(): void {
    //scrolling on top of page when user land dashboard
    window.scroll(0, 0);
    document.body.scrollTop = 0;
    const id = document.querySelector('body') as HTMLElement;
    id.scrollTo(0, 0);

    this.handleDashboardData();
  }

  //handled data ,direct login and  modal through dashboard api
  handleDashboardData(): void {
    this.dashboardService.getDashboardData().subscribe((res) => {
      this.global.loadGoogleAnalytics('UA-9249317-12')
      localStorage.setItem('redirect', res.direct_login_status);
      this.dashboardService.mapsAndProfile = res;
      this.data = res;
      this.dashboardService.isDataLoaded(res);

      let dialog1: any;
      //to show direct login modal
      if (this.data.direct_login_status == '') {
        dialog1 = this.dialog.open(NewFutureModalComponent, {
          panelClass: 'app-full-bleed-dialog',
          backdropClass: 'bdropDark',
        });

        dialog1.afterClosed().subscribe(() => {
          if (this.data.welcome_modal_show === 'true') {
            const dialogRef = this.dialog.open(DynamicModalComponent, {
              position: {
                top: '10.1%',
                left: '25%',
              },
              data: {
                all_data: this.data.welcome_note,
              },
              disableClose: false,
              backdropClass: 'cdk-overlay-transparent-backdrop',
            });
            dialogRef.afterClosed().subscribe(() => {
              let dialogRef3: any;
              //to show purchase modal
              if (localStorage.getItem('signUp')) {
                dialogRef3 = this.dialog.open(PurchaseModalComponent, {
                  panelClass: 'app-full-bleed-dialog',
                  disableClose: false,
                  backdropClass: 'cdk-overlay-transparent-backdrop',
                });
                dialogRef3.afterClosed().subscribe(() => {
                  if (
                    localStorage.getItem('first_login') == 'true' &&
                    !localStorage.getItem('signUp') &&
                    !localStorage.getItem('firstTime')
                  ) {
                    localStorage.setItem('first_login', 'false');
                    // this.dialog.open(WelcomeBackComponent, {
                    //   panelClass: 'app-full-bleed-dialog',
                    //   position: {
                    //     top: '10%',
                    //   },
                    //   disableClose: false,
                    //   backdropClass: 'cdk-overlay-transparent-backdrop',
                    // });
                  }
                  localStorage.removeItem('signUp');
                });
              } else {
                if (
                  localStorage.getItem('first_login') == 'true' &&
                  !localStorage.getItem('signUp') &&
                  !localStorage.getItem('firstTime')
                ) {
                  localStorage.setItem('first_login', 'false');
                  // this.dialog.open(WelcomeBackComponent, {
                  //   position: {
                  //     top: '10%',
                  //   },
                  //   panelClass: 'app-full-bleed-dialog',
                  //   disableClose: false,
                  //   backdropClass: 'cdk-overlay-transparent-backdrop',
                  // });
                }
              }
            });
          } else {
            if (
              localStorage.getItem('first_login') == 'true' &&
              !localStorage.getItem('signUp') &&
              !localStorage.getItem('firstTime')
            ) {
              localStorage.setItem('first_login', 'false');
              // this.dialog.open(WelcomeBackComponent, {
              //   position: {
              //     top: '10%',
              //   },
              //   panelClass: 'app-full-bleed-dialog',
              //   disableClose: false,
              //   backdropClass: 'cdk-overlay-transparent-backdrop',
              // });
            }
          }
        });
      } else if (
        this.data.direct_login_status != '' &&
        this.data.welcome_modal_show === 'true'
      ) {
        if (this.data.welcome_modal_show === 'true') {
          const dialogRef = this.dialog.open(DynamicModalComponent, {
            position: {
              top: '10.1%',
              left: '25%',
            },
            data: {
              all_data: this.data.welcome_note,
            },
            disableClose: false,
            backdropClass: 'cdk-overlay-transparent-backdrop',
          });
          dialogRef.afterClosed().subscribe(() => {
            let dialogRef3: any;
            if (localStorage.getItem('signUp')) {
              dialogRef3 = this.dialog.open(PurchaseModalComponent, {
                panelClass: 'app-full-bleed-dialog',
                disableClose: false,
                backdropClass: 'cdk-overlay-transparent-backdrop',
              });
              dialogRef3.afterClosed().subscribe(() => {
                if (
                  localStorage.getItem('first_login') == 'true' &&
                  !localStorage.getItem('signUp') &&
                  !localStorage.getItem('firstTime')
                ) {
                  localStorage.setItem('first_login', 'false');
                  // this.dialog.open(WelcomeBackComponent, {
                  //   panelClass: 'app-full-bleed-dialog',
                  //   position: {
                  //     top: '10%',
                  //   },
                  //   disableClose: false,
                  //   backdropClass: 'cdk-overlay-transparent-backdrop',
                  // });
                }
              });
            } else {
              if (
                localStorage.getItem('first_login') == 'true' &&
                !localStorage.getItem('signUp') &&
                !localStorage.getItem('firstTime')
              ) {
                localStorage.setItem('first_login', 'false');
                // this.dialog.open(WelcomeBackComponent, {
                //   panelClass: 'app-full-bleed-dialog',
                //   position: {
                //     top: '10%',
                //   },
                //   disableClose: false,
                //   backdropClass: 'cdk-overlay-transparent-backdrop',
                // });
              }
            }
          });
        }
      } else if (localStorage.getItem('signUp')) {
        const dialogRef4 = this.dialog.open(PurchaseModalComponent, {
          panelClass: 'app-full-bleed-dialog',
          disableClose: false,
          backdropClass: 'cdk-overlay-transparent-backdrop',
        });
        localStorage.removeItem('signUp');
        dialogRef4.afterClosed().subscribe(() => {
          if (
            localStorage.getItem('first_login') == 'true' &&
            !localStorage.getItem('signUp') &&
            !localStorage.getItem('firstTime')
          ) {
            localStorage.setItem('first_login', 'false');
            // this.dialog.open(WelcomeBackComponent, {
            //   position: {
            //     top: '10%',
            //   },
            //   panelClass: 'app-full-bleed-dialog',
            //   disableClose: false,
            //   backdropClass: 'cdk-overlay-transparent-backdrop',
            // });
          }
        });
      } else if (
        localStorage.getItem('first_login') == 'true' &&
        !localStorage.getItem('signUp') &&
        !localStorage.getItem('firstTime')
      ) {
        localStorage.setItem('first_login', 'false');
        // this.dialog.open(WelcomeBackComponent, {
        //   panelClass: 'app-full-bleed-dialog',
        //   disableClose: false,
        //   backdropClass: 'cdk-overlay-transparent-backdrop',
        // });
      }
    });
  }
}
